module.exports = __webpack_public_path__ + "static/agi-cb8f2e3eadc6e7d936a8263e89d609ff.png";